document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('.mobile-menu-button');
  const menu = document.querySelector('#MobileMenu');
  if (button && menu) {
    const closeMenu = ({ returnFocus = false } = {}) => {
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-label', 'Open menu');
      menu.hidden = true;
      if (returnFocus) button.focus();
    };

    const openMenu = () => {
      button.setAttribute('aria-expanded', 'true');
      button.setAttribute('aria-label', 'Close menu');
      menu.hidden = false;
      menu.querySelector('a')?.focus();
    };

    const menuViewport = window.matchMedia('(max-width: 900px)');
    menuViewport.addEventListener('change', (event) => {
      if (!event.matches) closeMenu();
    });

    button.addEventListener('click', () => {
      if (button.getAttribute('aria-expanded') === 'true') closeMenu();
      else openMenu();
    });
    menu.addEventListener('click', (event) => {
      if (event.target.closest('a')) closeMenu();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') closeMenu({ returnFocus: true });
    });
  }

  const mobileViewport = window.matchMedia('(max-width: 900px)');
  const productGrid = document.querySelector('.product-grid');
  if (productGrid) {
    const originalCards = Array.from(productGrid.querySelectorAll('.product-card'));
    const mobileCards = [
      ...originalCards.filter((card) => card.classList.contains('featured')),
      ...originalCards.filter((card) => !card.classList.contains('featured'))
    ];
    const syncPackOrder = () => {
      const orderedCards = mobileViewport.matches ? mobileCards : originalCards;
      orderedCards.forEach((card) => productGrid.append(card));
    };
    syncPackOrder();
    mobileViewport.addEventListener('change', syncPackOrder);
  }

  const showGalleryImage = (thumb) => {
    const gallery = thumb?.closest('[data-product-gallery]');
    const mainImage = gallery?.querySelector('.pdp-gallery__display');
    const nextSource = thumb?.dataset.imageSrc;
    if (!mainImage || !nextSource) return;

    gallery.querySelectorAll('[data-product-thumb]').forEach((item) => {
      const selected = item === thumb;
      item.classList.toggle('is-active', selected);
      item.setAttribute('aria-pressed', String(selected));
    });

    const requestId = (gallery.galleryRequestId || 0) + 1;
    gallery.galleryRequestId = requestId;
    if (mainImage.src === nextSource) {
      gallery.galleryPendingSource = '';
      return;
    }
    gallery.galleryPendingSource = nextSource;

    const preloader = new Image();
    preloader.onload = () => {
      if (gallery.galleryRequestId !== requestId) return;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = nextSource;
      mainImage.alt = thumb.dataset.imageAlt || '';
      gallery.galleryPendingSource = '';
    };
    preloader.onerror = () => {
      if (gallery.galleryRequestId === requestId) gallery.galleryPendingSource = '';
    };
    preloader.src = nextSource;
  };

  const stickyAdd = document.querySelector('[data-sticky-add]');
  const stickyVariant = stickyAdd?.querySelector('[data-sticky-variant]');
  const stickyPrice = stickyAdd?.querySelector('[data-sticky-price]');
  const stickyButton = stickyAdd?.querySelector('[data-sticky-add-button]');
  const mainProductSubmit = document.querySelector('[data-product-submit]');
  const updateStickySelection = (option, available) => {
    if (!stickyAdd || !option) return;
    if (stickyVariant) stickyVariant.textContent = option.dataset.title || option.textContent.split('—')[0].trim();
    if (stickyPrice && option.dataset.price) stickyPrice.textContent = option.dataset.price;
    if (stickyButton) {
      stickyButton.disabled = !available;
      stickyButton.textContent = mainProductSubmit?.textContent || stickyButton.textContent;
    }
  };

  if (stickyAdd && mainProductSubmit) {
    let mainButtonVisible = false;
    let footerVisible = false;
    const updateStickyVisibility = () => {
      const visible = mobileViewport.matches && !mainButtonVisible && !footerVisible;
      stickyAdd.classList.toggle('is-visible', visible);
      stickyAdd.setAttribute('aria-hidden', String(!visible));
    };
    const visibilityObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === mainProductSubmit) mainButtonVisible = entry.isIntersecting;
        if (entry.target.classList.contains('site-footer')) footerVisible = entry.isIntersecting;
      });
      updateStickyVisibility();
    }, { threshold: 0.05 });
    visibilityObserver.observe(mainProductSubmit);
    const footer = document.querySelector('.site-footer');
    if (footer) visibilityObserver.observe(footer);
    mobileViewport.addEventListener('change', updateStickyVisibility);
    stickyButton?.addEventListener('click', () => mainProductSubmit.click());
  }

  document.addEventListener('pointerover', (event) => {
    const thumb = event.target.closest('[data-product-thumb]');
    if (!thumb || event.pointerType === 'touch' || thumb.contains(event.relatedTarget)) return;
    showGalleryImage(thumb);
  });

  document.addEventListener('focusin', (event) => {
    const thumb = event.target.closest('[data-product-thumb]');
    if (thumb) showGalleryImage(thumb);
  });

  document.addEventListener('change', (event) => {
    const variantSelect = event.target.closest('.pdp-form select[name="id"]');
    if (!variantSelect) return;
    const selectedOption = variantSelect.selectedOptions[0];
    const purchasePanel = variantSelect.closest('.pdp-purchase');
    const price = purchasePanel?.querySelector('[data-product-price]');
    const submit = purchasePanel?.querySelector('[data-product-submit]');
    const paymentButton = purchasePanel?.querySelector('[data-payment-button]');
    const available = selectedOption?.dataset.available === 'true';

    if (price && selectedOption?.dataset.price) price.textContent = selectedOption.dataset.price;
    if (submit) {
      submit.disabled = !available;
      submit.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
    }
    if (paymentButton) paymentButton.hidden = !available;
    updateStickySelection(selectedOption, available);

    const variantImage = selectedOption?.dataset.imageSrc;
    if (variantImage) {
      const gallery = document.querySelector('[data-product-gallery]');
      const matchingThumb = Array.from(gallery?.querySelectorAll('[data-product-thumb]') || []).find((thumb) => thumb.dataset.imageSrc === variantImage);
      if (matchingThumb) showGalleryImage(matchingThumb);
    }
  });

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-product-thumb]');
    if (thumb) {
      showGalleryImage(thumb);
      return;
    }

    const quantityButton = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!quantityButton) return;
    const input = quantityButton.closest('[data-quantity-control]')?.querySelector('input');
    if (!input) return;
    const direction = quantityButton.hasAttribute('data-quantity-plus') ? 1 : -1;
    input.value = String(Math.max(1, Number(input.value || 1) + direction));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
});
